import { IBudgetConstruction } from '@apply/api/src/api/ApplyApi';
import { MoneyBox } from '@apply/components';
import { formatCurrencyOrUndefined } from '@apply/ui';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';
import { useBudgetConstructionField } from '../../../../../queries/useBudgetConstructionField';

interface WindowsAndDoorsProps {
    required?: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const WindowsAndDoors: React.FC<WindowsAndDoorsProps> = ({ required = false, propertyGuid, isReview = false }) => {
    const [windowsAndDoors, set_windowsAndDoors] = useBudgetConstructionField<number>(
        propertyGuid,
        (b) => b.values?.['Exterior Finishes']?.['Windows & Doors'] ?? 0,
        (b, v) => ({ ...b, values: { ...b.values, 'Exterior Finishes': { ...b.values?.['Exterior Finishes'], 'Windows & Doors': v } } })
    );
    const label = 'Windows and Doors';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={formatCurrencyOrUndefined(windowsAndDoors)}
                />
            ) : (
                <MoneyBox
                    id={'windowsAndDoors'}
                    allowNegative={false}
                    value={windowsAndDoors}
                    onChange={(value) => set_windowsAndDoors(value)}
                    required={required}
                    label={label}
                />
            )}
        </>
    );
};
